import { LazyFallback } from 'components/shared/LazyFallback';
import { FC, Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const PriceImprovementBlotterRouteLazy = lazyWithRetry(() => import('./PriceImprovementBlotter'));
export const PriceImprovementBlotterRoute: FC = () => (
  <Suspense fallback={<LazyFallback />}>
    <PriceImprovementBlotterRouteLazy />
  </Suspense>
);
